'use client'

import { useMenuFooterCopy, useShowMenuLocaleSwitcher } from '@/context/site-chrome-copy'
import { getFooterLinks, type FooterLinkId } from './footer-links'
import MenuLocaleSwitcher from './menu-locale-switcher'

const linkClassName =
    'text-left text-xs leading-4 font-semibold text-white/65 transition-colors hover:text-giphyWhite focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-giphyWhite'

// Reads down the two-column grid in the order the mobile design lays it out.
const FOOTER_LINK_ORDER: FooterLinkId[] = ['termsOfService', 'manageCookies', 'privacyPolicy', 'dmca', 'copyright']

const MobileMenuFooter = () => {
    const copy = useMenuFooterCopy()
    const footerLinks = getFooterLinks(copy)
    const showLocaleSwitcher = useShowMenuLocaleSwitcher()

    return (
        <footer className="relative bg-[rgba(0,0,0,0.40)] px-5 pt-7 pb-[110px] text-giphyWhite">
            <div className="mb-7 text-left text-base leading-5 font-bold">{`© ${new Date().getFullYear()} GIPHY, Inc.`}</div>
            <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                {FOOTER_LINK_ORDER.map((id) => {
                    const link = footerLinks[id]

                    return link.onClick ? (
                        <button
                            key={id}
                            type="button"
                            onClick={link.onClick}
                            className={`${linkClassName} cursor-pointer border-none bg-transparent p-0`}
                        >
                            {link.label}
                        </button>
                    ) : (
                        <a key={id} href={link.href} className={linkClassName}>
                            {link.label}
                        </a>
                    )
                })}
                {showLocaleSwitcher && (
                    <MenuLocaleSwitcher
                        localeSwitcher={copy.localeSwitcher}
                        buttonClassName={linkClassName}
                        popoverClassName="min-w-[118px]"
                    />
                )}
            </div>
        </footer>
    )
}

export default MobileMenuFooter
